import { render, staticRenderFns } from "./PhotoSwipe.vue?vue&type=template&id=9ec77ee0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PhotoSwipe.vue"
export default component.exports